import {store} from './utilities'
import {activate, edit} from './action_creators'

export default function switchSection(id) {
  store.dispatch(activate('section', id))
  store.dispatch(activate('field', null))
  //Prevent issue where you could be editing a field on another section preventing drag/drop
  store.dispatch(edit(null))
}
